<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex v-if="getProfileHaveClient">
        <v-card>
          <v-layout row wrap>
          <v-flex xs12 md8>
            <v-client-page :mode="'mainPage'" :itemId = "profile.clientInn"></v-client-page>
          </v-flex>
          <v-flex xs12 md4>
            <v-container
            fluid
            style="min-height: 0;"
            grid-list-md
          >
          <v-layout column>
           <v-flex >
            <v-card to="/doc_list/root" color="grey lighten-4">
              <v-card-title primary-title class="title">
                Депозитарий
              </v-card-title>
              <v-card-text>
              Сервис позволяет задепонировать документы и гарантирует что документы были опубликованы именно в том виде в каком они существуют. Вы можете ссылаться на задепонированные документы и использовать их для разрешения спорных ситуаций
              </v-card-text>
            </v-card>
           </v-flex>
           <v-flex >
            <v-card to="/chats/root" color="grey lighten-4">
              <v-card-title primary-title class="title">
                  <v-badge v-show="counters.notReviewedChats > 0" right>
                    <span slot="badge">{{counters.notReviewedChats}}</span>
                    <span>Сообщения</span>
                  </v-badge>
                    <span v-show="!counters.notReviewedChats || counters.notReviewedChats === 0">Сообщения</span>
                  </div>
              </v-card-title>
              <v-card-text>
              Сервис позволяет обмениваться сообщениями, как и многие другие сервисы. Отличие Системы "АТЛАНТ-СМАРТ" в том, что вся переписка хранится в надежной базе Системы "АТЛАНТ-СМАРТ" и может быть использована для решения спорных ситуаций.
              </v-card-text>
            </v-card>
           </v-flex>
           <v-flex >
            <v-card to="/monitoring_page" color="grey lighten-4">
              <v-card-title primary-title class="title">
                Мониторинг контрагентов
              </v-card-title>
              <v-card-text>
              Сервис позволяет отслеживать изменения, которые вносятся в ЕГРЮЛ вашими контрагентами. Это позволяет избежать сюрпризов и быть в курсе об изменениях, происходящих у Ваших партнеров.
              </v-card-text>
            </v-card>
           </v-flex>
          </v-layout>
          </v-container>
        </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex v-if="!getProfileHaveClient">
        <v-home-panel></v-home-panel>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vClientPage from './info/ClientPage.vue'
  import vHomePanel from './HomePanel.vue'

  export default {
    components: {vClientPage, vHomePanel},
    data: () => ({
    }),
    mounted () {
      if (this.getProfileHaveClient) {
        this.$store.dispatch('fetchDashboardCounters')
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient',
        profile: 'getProfile',
        counters: 'getDashboardCounters'
      })
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// MainPage.vue?11d8df66